module.exports = __webpack_public_path__ + "media/images/ajax-loader-fb6f3c230cb846e25247dfaa1da94d8f.gif";